<template>
  <span>
    <ul v-if="customers.length">
      <li v-for="(item, i) in customersToShow" :key="i">
        <customer-card
          :customer="item"
          :was-search-by-licence-plate="wasSearchByLicencePlate"
          :is-purchase-order="isPurchaseOrder"
          @select-result="selectCustomer"
          @select-vehicle-customer-to-change="selectVehicleCustomerToChange"
        />
      </li>
    </ul>
    <div v-if="hasSearched && customers.length == 0">
      <p>{{ i18n.t('/KlantZoekenModal/GeenKlantGevonden') }}</p>
    </div>

    <app-button
      v-if="amountToShow <= customers.length"
      data-qa="show-more-customers-button"
      @click="showMoreResults()"
    >
      {{ i18n.t('/KlantZoekenModal/ToonMeer') }}
    </app-button>
  </span>
</template>

<script>
import CustomerCard from '@/components/generic/presentational/molecules/customerCard/CustomerCard.vue'
import AppButton from '@/components/generic/presentational/atoms/appButton/AppButton.vue'

export default {
  components: {
    CustomerCard,
    AppButton,
  },
  props: {
    customers: {
      type: Array,
      default: () => [],
    },
    hasSearched: {
      type: Boolean,
      default: false,
    },
    wasSearchByLicencePlate: {
      type: Boolean,
      default: false,
    },
    isPurchaseOrder: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['selectCustomer', 'selectVehicleCustomerToChange'],
  data() {
    return {
      amountToShow: 20,
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
    }
  },
  computed: {
    customersToShow() {
      return this.customers.filter((customer, index) => index < this.amountToShow)
    },
  },
  methods: {
    showMoreResults() {
      this.amountToShow += 20
    },
    selectCustomer(customer) {
      this.$emit('selectCustomer', customer)
    },
    selectVehicleCustomerToChange(customer) {
      this.$emit('selectVehicleCustomerToChange', customer)
    },
  },
}
</script>

<style lang="scss" scoped>
ul {
  @include list-reset;
}
</style>
